import {
  HTTP_GETPROJECT_FETCHING,
  HTTP_GETPROJECT_SUCCESS,
  HTTP_GETPROJECT_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETPROJECT_FETCHING:
      return {
        ...state,
        result: null,
        isFetching: true,
        isError: false,
      };
    case HTTP_GETPROJECT_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETPROJECT_FAILED:
      return {
        ...state,
        result: null,
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
